import PubSub from 'pubsub-js';

const $html = $('html');
const $header = $('.header');

PubSub.subscribe('init', () => {
    $('.local-menuToggle').on('click', () => {
        if ($html.hasClass('-showMenu')) {
            $html.removeClass('-showMenu');
        } else {
            $html.addClass('-showMenu');
        }
    });
});

PubSub.subscribe('scroll', (_msg, {scrollDirection, scrollTop}) => {
    $html.removeClass('-opening');
    if (scrollDirection === 'down' && scrollTop > 0) {
        $header.addClass('-scrollDown');
    } else {
        $header.removeClass('-scrollDown');
    }
});